/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import getHCConfigPropertyKey from './getHCConfigPropertyKey';

const getDecimalPlaces = (formattingOptions :any) => {

    let decimalPlaces :any = '1';
    if (typeof formattingOptions.gaugesDecimalPlaces !== 'undefined') {
        decimalPlaces = formattingOptions.gaugesDecimalPlaces;
    }

    const valueFromProperties = getHCConfigPropertyKey(formattingOptions, 'plotOptions.solidgauge.tooltip.valueDecimals');
    if (valueFromProperties) {
        decimalPlaces = valueFromProperties;
    }

    if (typeof decimalPlaces === 'string' && decimalPlaces !== '') {
        decimalPlaces = parseInt(decimalPlaces, 10);
        if (Number.isNaN(decimalPlaces)) {
            decimalPlaces = 1;
        }
    }

    return decimalPlaces;
};

export default getDecimalPlaces;
